module.exports = __webpack_public_path__ + "0808bb6a354d793322d37c7e1e13bdfa.svg";